<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  color?: any
  symbol?: boolean
}>()

const background_color = computed(() => {
  return !props.symbol ? props.color : { color: '#FFFFFF' }
})

const foreground_color = computed(() => {
  return props.symbol ? { color: '#e55a05' } : { color: '#FFFFFF' }
})
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 35"
    :style="background_color"
    class="eb-icon-nosize w-10 h-10 p-1"
  >
    <path
      d="m11.159,33.807c-9.006,-3.503 -13.466,-13.64 -9.966,-22.647c3.503,-9.007 13.644,-13.47 22.648,-9.964c9.006,3.498 13.466,13.642 9.966,22.645c-3.503,9.008 -13.644,13.467 -22.648,9.966"
    />
    <line
      y2="23.12455"
      x2="25.87491"
      y1="23.18705"
      x1="9.12509"
      stroke="#ffffff"
      fill="none"
    />
    <line
      transform="rotate(90 17.5 25.5308)"
      stroke="#ffffff"
      y2="25.49953"
      x2="19.93747"
      y1="25.56203"
      x1="15.06253"
      fill="none"
    />
    <line
      transform="rotate(90 9.56259 17.5934)"
      stroke="#ffffff"
      y2="17.49962"
      x2="19.87497"
      y1="17.56212"
      x1="15.00003"
      fill="none"
    />
    <line
      transform="rotate(90 25.4375 25.5308)"
      stroke="#ffffff"
      y2="25.49953"
      x2="27.87489"
      y1="25.56203"
      x1="22.99994"
      fill="none"
    />
    <line
      transform="rotate(90 17.5 21.0933)"
      stroke="#ffffff"
      y2="21.06208"
      x2="19.93747"
      y1="21.12458"
      x1="15.06253"
      fill="none"
    />
    <ellipse
      stroke="#ffffff"
      ry="0.90624"
      rx="0.84374"
      cy="27.96825"
      cx="17.53125"
      :fill="foreground_color.color"
    />
    <ellipse
      stroke="#ffffff"
      ry="0.90624"
      rx="0.84374"
      cy="27.96825"
      cx="25.40616"
      :fill="foreground_color.color"
    />
    <ellipse
      stroke="#ffffff"
      ry="0.90624"
      rx="0.84374"
      cy="27.96825"
      cx="9.59384"
      :fill="foreground_color.color"
    />
    <rect
      stroke="null"
      rx="1"
      height="14.5968"
      width="10.99087"
      y="5.34071"
      x="12.00457"
      :fill="foreground_color.color"
    />
    <ellipse
      stroke="null"
      ry="0.91063"
      rx="0.93256"
      cy="15.27826"
      cx="21.19694"
      :fill="background_color.color"
    />
    <ellipse
      stroke="null"
      ry="0.91063"
      rx="0.93256"
      cy="12.63744"
      cx="21.19693"
      :fill="background_color.color"
    />
    <ellipse
      stroke="null"
      ry="0.91063"
      rx="0.93256"
      cy="17.91908"
      cx="21.19694"
      :fill="background_color.color"
    />
  </svg>
</template>
